var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-time-picker',{staticClass:"base-time-picker",attrs:{"value-format":_vm.valueFormat,"format":_vm.format},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }